import { render, staticRenderFns } from "./UserGroup.vue?vue&type=template&id=2847e326&scoped=true"
import script from "./UserGroup.vue?vue&type=script&lang=js"
export * from "./UserGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2847e326",
  null
  
)

export default component.exports